export default function IloveMeIcon({ className = "inline-flex items-center gap-1" }) {
    return (
        <span className={className}>
            <img src="https://ilove.me/favicon.ico" alt="" className="h-4 w-4" />
            ilove.me
        </span>
    );
}
